import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { updateShift } from "@redux/actions";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { toast } from "react-toastify";
import { NO_CHANGES_MADE } from "@utils/constants";
import { formatDateReverse, formatTime } from "@utils/utils";
import {
  modalStyle,
  modalBody,
  modalHeader,
  styles,
} from "@styles/styledComponents";

class updateShifts extends React.Component {
  constructor(props) {
    super(props);
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };
  updateForm = async (event) => {
    event.preventDefault();
    if (!this.state) {
      toast(NO_CHANGES_MADE, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark",
        type: "info",
      });
      return;
    }

    const response = await this.props.updateShift(
      this.state,
      this.props.shiftData._id
    );
    const { message, success } = response.data;
    toast(message, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: success ? "success" : "error",
    });
    setTimeout(() => {
      this.props.openModal();
    }, 1000);
  };
  render() {
    const { classes, shiftData } = this.props;
    return (
      <>
        <div>
          <Modal
            open={true}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            style={modalStyle}
          >
            <Fade in={true}>
              <Paper elevation={1} variant="normal" square>
                <div style={modalHeader}>
                  <p>Update Shift Status</p>
                </div>
                <div style={modalBody}>
                  <Paper className={classes.paper}>
                    <form
                      className={classes.form}
                      autoComplete="off"
                      onSubmit={this.updateForm}
                    >
                      <TextField
                        id="shift_name"
                        name="shift_name"
                        label="Shift Name"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={shiftData.shift_name}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="working_hours"
                        name="working_hours"
                        label="Working Hours"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={shiftData.working_hours}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="start_time"
                        name="start_time"
                        label="Start Time"
                        type="time"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={formatTime(shiftData.start_time)}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="end_time"
                        name="end_time"
                        label="End Time"
                        type="time"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={formatTime(shiftData.end_time)}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="start_date"
                        name="start_date"
                        label="Start Date (inclusive)"
                        type="date"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={formatDateReverse(shiftData.start_date)}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="end_date"
                        name="end_date"
                        label="End Date (inclusive)"
                        type="date"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={formatDateReverse(shiftData.end_date)}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="late_allowed"
                        name="late_allowed"
                        label="Mark Late after (minutes)"
                        type="number"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={shiftData.late_allowed}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="half_leave_after"
                        name="half_leave_after"
                        label="Mark Half Leave after (minutes)"
                        type="number"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={shiftData.half_leave_after}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="full_leave_after"
                        name="full_leave_after"
                        label="Mark Full Leave after (minutes)"
                        type="number"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={shiftData.full_leave_after}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <br />

                      <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="flex-end"
                      >
                        <Grid item>
                          <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            onClick={this.props.openModal}
                          >
                            Close
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            onClick={this.updateForm}
                          >
                            Update
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Paper>
                </div>
              </Paper>
            </Fade>
          </Modal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    employees: state.shift?.length && state.shift[0].payload,
  };
};

export default connect(mapStateToProps, { updateShift })(
  withStyles(styles)(updateShifts)
);
